import React from "react";
import Table from "../../components/Table";
import { Column } from "../../components/BaseTable";
import { HuidigeSituatiePersonalia } from "../../../../.generated/rapportage/rapportagetypes";

export interface PersonaliaTableProps {
  data: HuidigeSituatiePersonalia[];
}

export const PersonaliaTable: React.FC<PersonaliaTableProps> = ({
  data,
}: PersonaliaTableProps) => {
  const columns: Column<HuidigeSituatiePersonalia>[] = [
    {
      header: "Personalia",
      accessor: "naam",
    },
    {
      header: "Adres",
      accessor: (row) =>
        row.straat && row.postcode && row.plaats
          ? `${row.straat}\n${row.postcode} ${row.plaats}`
          : null,
    },
    {
      header: "Geboortedatum",
      accessor: "geboortedatum",
      dataType: "date",
    },
    {
      header: "Geslacht",
      accessor: "geslacht",
    },
    {
      header: "Burgerlijke staat",
      accessor: "burgerlijkeStaat",
    },
    {
      header: "Telefoon",
      accessor: "telefoonnummerMobiel",
    },
    {
      header: "E-mail",
      accessor: "emailadres",
    },
  ];

  return (
    <Table
      columns={columns}
      data={data}
      rotate={true}
      showHeader={true}
      filterNullAnd0Columns={true}
      id="personalia-table"
      regularStyles={data?.length > 1}
    />
  );
};
